export default __webpack_public_path__ + "static/media/defalut_male_img.aa0f6279.jpeg";